import { ROOT_REDIRECT_CRAWLER_RE } from "@/config/crawler-user-agents.mjs";

/**
 * Erkennt Such- und AI-Crawler am User-Agent.
 *
 * Zweck: geo-basierte Umleitungen fuer Crawler abschalten, damit die Root-Domain
 * konsistent auf das x-default-Ziel zeigt. Google empfiehlt ausdruecklich, Googlebot
 * nicht geo-umzuleiten. Der sichtbare Seiteninhalt bleibt fuer alle identisch,
 * es geht ausschliesslich um das Redirect-Ziel.
 *
 * Die Token stammen aus src/config/crawler-user-agents.mjs, derselben Quelle wie
 * die Nginx-Map gegen Crawler-Prefetches (Plan 2026-10-06 A-2 und A-4).
 * Google-Crawler mit `Google-`-Praefix oder `-Google`-Suffix (Google-InspectionTool,
 * Storebot-Google) zaehlen mit.
 */
export function isCrawlerUserAgent(ua: string | null | undefined): boolean {
	if (!ua) return false;
	return ROOT_REDIRECT_CRAWLER_RE.test(ua);
}
